//
//
//
//
//
//

import { setOwnKey } from '@/tools'
export default {
  props: {},
  data() {
    return {
      question: {
        v_ownId: setOwnKey(),
        v_active: false,
        v_label: '填空题',
        type: 'blank',
        displayIndex: true,
        title: '请填写本项内容',
        required: true,
        size: 'small',
        rule: 'ignore',
        minLength: null,
        maxLength: null,
        uploadArrow: true,
        uploadArrowRequired: false,
        logic: {
          blocks: {
            typeBlock: 'all',
            list: [],
          },
        },
      },
    }
  },
  methods: {
    chooseItem() {
      this.$emit('choose', this.question)
    },
  },
}
